<template lang="pug">
div
  el-row.labelDiv(:gutter="30")
    el-col.inputDiv(:span="8")
      validation-provider(rules="required", v-slot="{ errors }", name="Imóvel/Denominação")
        app-label(label="Denominação do Imóvel:")
        el-input.input(
          v-model="imovel.denominacao",
          name="Denominação do Imóvel",
          maxlength="300"
          :class="{'erro' : errors.length}"
          @input="toUppercase($event, 'imovel','denominacao')"
        )
        span.help.erro {{ errors[0] }}
    el-col.inputDiv(:span="8")
      validation-provider(rules="required", v-slot="{ errors }", name="Imóvel/gleba")
        app-label(label="Gleba:")
        el-input.input(
          v-model="imovel.gleba",
          name="Gleba",
          maxlength="300"
          :class="{'erro' : errors.length}"
          @input="toUppercase($event, 'imovel','gleba')"
        )
        span.help.erro {{ errors[0] }}
    el-col.inputDiv(:span="6")
      validation-provider(rules="required", v-slot="{ errors }", name="Imóvel/localizaçãosede")
        app-label(label="UF localização da sede:")
        el-input.input(
          v-model="imovel.ufLocalizacaoSede",
          name="UF localização da sede",
          maxlength="300"
          :class="{'erro' : errors.length}"
          :disabled="true"
        )
        span.help.erro {{ errors[0] }}
  el-row.labelDiv(:gutter="30")
    el-col.inputDiv(:span="8")
      validation-provider(rules="required", v-slot="{ errors }", name="Imóvel/Município")
        app-label( label="Município:")
        el-select.input(
          class="select",
          v-model="imovel.municipio",
          no-match-text="Nenhum Município Encontrado",
          placeholder="Selecione",
          filterable,
          clearable,
          @clear="imovel.municipio = null"
          value-key="id",
          name="Município",
          :class="{'erro' : errors.length}"
        )
          el-option(
            v-for="item in municipios",
            :key="item.id",
            :label="item.nome",
            :value="item"
          )
        span.help.erro {{ errors[0] }}

    el-col.inputDiv(:span="8")
      div.inputArea
        validation-provider(:rules="isRequiredArea", v-slot="{ errors }", name="Imóvel/Área")
          app-label(label="Área:")
          app-double-input.input(
            v-model="imovel.area",
            name='Área',
            :precision="4",
            :onkeypress="onlyInputNumbers",
            :class="{'erro' : errors.length}",
            :showAppend ="false",
          )
          span.help.erro {{ errors[0] }}
          p.conversao(v-if="imovel.area && imovel.tipoArea") Conversão: {{ conversaoAreaCadastro() }}
        validation-provider(rules="required", v-slot="{ errors }", name="Imóvel/TipoArea")
          app-label( label="Tipo:")
          el-select.input(
            class="select",
            v-model="imovel.tipoArea",
            placeholder="Selecione",
            filterable,
            clearable,
            @clear="imovel.tipoArea = null"
            value-key="id",
            name="Tipo",
            :class="{'erro' : errors.length}"
          )
            el-option(
              v-for="item in tiposArea",
              :key="item.id",
              :label="item.nome",
              :value="item.codigo"
            )
          span.help.erro {{ errors[0] }}

  el-row(:gutter="30")
    el-col(:span="24")
      validation-provider(rules="required", v-slot="{ errors }", name="Imóvel/Localização")
        app-label(label="Localização:")
        el-input.input(
          v-model="imovel.localizacao",
          name='Localização',
          type="textarea",
          :rows="5",
          :class="{'erro' : errors.length}"
          @input="toUppercase($event, 'imovel','localizacao')"
        )
        span.help.erro {{ errors[0] }}

  el-row(:gutter="30")
    el-col(:span="5")
      validation-provider(v-slot="{ errors }", name="Imóvel/Latitude")
        app-label(label="Latitude:", :required="false")
        el-input.input(
          v-model="imovel.latitude",
          name='Latitude',
          :class="{'erro' : errors.length}"
          v-mask="[`##°##'##,###\"A`]"

        )
        span.help.erro {{ errors[0] }}
    el-col(:span="5")
      validation-provider(v-slot="{ errors }", name="Imóvel/Longitude")
        app-label(label="Longitude:", :required="false")
        el-input.input(
          v-model="imovel.longitude",
          name='Longitude',
          :class="{'erro' : errors.length}"
          v-mask="[`##°##'##,###\"A`]"
        )
        span.help.erro {{ errors[0] }}
    el-col(:span="13")
      validation-provider(v-slot="{ errors }", name="Imóvel/Logradouro")
        app-label(label="Logradouro:", :required="false")
        el-input.input(
          v-model="imovel.logradouro",
          name='Logradouro',
          :class="{'erro' : errors.length}"
          @input="toUppercase($event, 'imovel','logradouro')"
        )
        span.help.erro {{ errors[0] }}
  el-row(:gutter="30")
    el-col(:span="10")
      validation-provider(rules="required" v-slot="{ errors }", name="Imóvel/Bairro")
        app-label(label="Bairro/Povoado", :required="true")
        el-input.input(
          v-model="imovel.bairro",
          name='Bairro',
          :class="{'erro' : errors.length}"
          @input="toUppercase($event, 'imovel','bairro')"
        )
        span.help.erro {{ errors[0] }}
    el-col.inputDiv(:span="8")
        validation-provider(v-slot="{ errors }", name="Imóvel/Número")
          app-label(label="Número:", :required="false")
          el-input.input(
            name='numero'
            v-model="imovel.numero",
            :disabled="imovel.semNumero",
            :onkeypress="onlyInputNumbers",
            maxlength="10"
            :showAppend ="true",
            :class="{'erro' : errors.length}"
          )
            el-checkbox.input(
              v-model="imovel.semNumero",
              label="S/N", slot="prepend",
              @change="onSemNumeroCheck"
            )
          span.help.erro {{ errors[0] }}

</template>
<script>
import onlyInputNumbers from '@/components/mixins/OnlyInputNumber'
import AppDivider from '@/components/AppDivider'
import AppLabel from '@/components/AppLabel'
import AppDoubleInput from '@/components/AppDoubleInput'
import { conversaoAreaTexto } from '@/utils/utils'

const { tiposArea } = require('@/utils/' +
  process.env.ESTADO +
  '/regrasCentral').default

export default {
  mixins: [onlyInputNumbers],
  components: {
    AppDivider,
    AppLabel,
    AppDoubleInput
  },
  props: {
    imovel: {
      required: true
    },
    required: {
      type: Boolean,
      default: true
    }
  },
  data () {
    return {
      municipios: [],
      tiposArea: tiposArea
    }
  },
  created () {
    this.getMunicipiosByUf()
  },

  computed: {
    isRequiredArea () {
      return this.required ? 'required|min_value:0.00001' : ''
    }
  },

  methods: {
    async getMunicipiosByUf () {
      this.municipios = await this.$store.dispatch(`municipios/findMunicipiosByUf`, process.env.ESTADO)
      this.municipios.forEach(element => {
        element.nome = element.nome.toUpperCase()
      })
    },
    toUppercase (valor, primeiro, segundo) {
      this[primeiro][segundo] = valor.toUpperCase()
    },
    onSemNumeroCheck (checked) {
      if (checked) {
        this.imovel.numero = 0
        return
      }

      this.imovel.numero = null
    },
    conversaoAreaCadastro () {
      return conversaoAreaTexto(this.imovel.area, this.imovel.tipoArea)
    }
  }
}
</script>

<style lang="scss" scoped>
.el-row {
  margin-bottom: 20px;
}
.select {
  width: 100%;
}
.inputArea {
  display: flex;
  flex-direction: row;
}
.conversao {
  margin-top: 5px;
  font-size: 13px;
}
@media (max-width: 780px) {
  .labelDiv {
    display: flex;
    flex-direction: column;
  }
  .inputDiv {
    width: 85%;
  }
}
</style>



// WEBPACK FOOTER //
// src/screens/central/cadastros/maranhao/processoFisico/components/DominacaoImovel.vue